import { render, staticRenderFns } from "./myGroups.vue?vue&type=template&id=7a8f54b5&scoped=true&lang=pug&"
import script from "./myGroups.vue?vue&type=script&lang=js&"
export * from "./myGroups.vue?vue&type=script&lang=js&"
import style0 from "./myGroups.vue?vue&type=style&index=0&id=7a8f54b5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8f54b5",
  null
  
)

export default component.exports